/**
 * The MIT License (MIT)
 * Copyright (c) 2017-present Dmitry Soshnikov <dmitry.soshnikov@gmail.com>
 */

'use strict';

module.exports = {
  // "dotAll" `s` flag
  dotAll: require('./compat-dotall-s-transform'),

  // Named capturing groups.
  namedCapturingGroups: require('./compat-named-capturing-groups-transform'),

  // `x` flag
  xFlag: require('./compat-x-flag-transform')
};